// extracted by mini-css-extract-plugin
module.exports = {"vertical":"style_vertical__2lQ0P"};